import React from 'react';
import { reduxForm, Field } from 'redux-form'
import { withTranslation } from 'react-i18next';
import { FormGroup, ModalHeader, Button, ModalBody,Label, Nav, NavItem, NavLink } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { isMobile } from "react-device-detect";
import { onDropAlphawithsinglespace, avoidPasting } from 'lib/fp-utility';

class UPIPayment extends React.Component {
    state = {
        vpaNo: null,
        error: "",
        vpaInvalid: false,
        touched: false
    }
    toggle = this.toggle.bind(this);

    validateVPA(vpaNo){ 
        const pattern = /^[^\s@]+@[^\s@]+$/
        // console.log("VAlidate method: ", vpaNo)
        this.setState({
            touched: true, 
            vpaInvalid: !pattern.test(vpaNo)
        })
    }

    toggle(){
        this.setState({
            touched: true
        })
    }

    render() {
        const {t} = this.props
        return (
            <>
                <ModalHeader toggle={this.props.closeVpaModal}>{t('upi_popup_title')}</ModalHeader>
                <ModalBody>
                    <div className="text-center">
                        <p className="text-16">{t('registered_vpa')}</p>
                        <FormGroup className="upi-popup">
                            {/* <Input className="text-center" name="" onChange={(e) => this.setState({vpaNo: e.target.value})} /> */}
                            <Field 
                                className="text-center" 
                                type='text' 
                                autoComplete='off' 
                                name="vpaNo"
                                onPaste={avoidPasting}
                                onDrop={onDropAlphawithsinglespace}
                                onChange={(e)=> {
                                        this.setState({vpaNo: e.target.value}, () =>{
                                            this.validateVPA(this.state.vpaNo)
                                        })
                                    }
                                }
                                component='input'
                                placeholder='Please enter your VPA detail here'
                            />
                            <div style={{minHeight: 24}}>
                                { this.state.vpaInvalid && <span className="error">Please enter a valid VPN</span>}
                            </div>
                        </FormGroup>
                    </div>
                    <div className="note-popup">
                        <Label>{t('Note')}:</Label>
                        <Nav>
                            {t('upi_popup_notes', {returnObjects: true}).map(({id, note}) => (
                                <NavItem key={id}>{note}</NavItem>
                            ))}
                            { !isMobile &&
                                <NavItem>
                                    <NavLink onClick={() => this.props.changePayment("BHARATQR")}>
                                        {t('remember_vpa')}
                                    </NavLink>
                                </NavItem>
                            }
                        </Nav>
                    </div>
                    <div className="inclusivePrice">
                        {
                            this.props.transactionDetails && 
                            <Label>
                                {this.props.t(this.props.transactionDetails.currencyCode)}&nbsp;
                                {this.props.transactionDetails.amount}
                            </Label>
                        }
                    </div>
                    <Button disabled={(this.state.vpaInvalid || !this.state.touched || this.props.OnProcessUPI)} className="float-right mt-3" onClick={()=>this.props.submitVPA(this.state.vpaNo)}>{t('send_request')}</Button>
                </ModalBody>
            </>
        )
    }
}

const UPIContent = reduxForm({
    form: 'upi_form'
})(UPIPayment)

export default withTranslation('translations')(modalWrapper(true, "UPIPaymentModal")(UPIContent));